import React from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const ErrorState = ({ onRetry }) => {
  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="max-w-md mx-auto text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-error bg-opacity-10 mb-6">
          <Icon name="AlertTriangle" size={32} className="text-error" />
        </div>
        <h2 className="text-2xl font-bold text-slate-900 mb-2">
          Unable to load technologies
        </h2>
        <p className="text-slate-600 mb-6">
          We encountered an issue while loading the technology data. Please try again or contact support if the problem persists.
        </p>
        <Button
          variant="primary"
          size="lg"
          icon="RefreshCw"
          onClick={onRetry}
        >
          Try Again
        </Button>
      </div>
    </div>
  );
};

export default ErrorState;